exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background:#f0f3f7!important}.content-wrapper{background:#fff;padding:25px;border:1px solid #d9dde4;display:table;border-radius:3px!important;width:100%}.sidebar-wrapper{border-right:1px solid #eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a507b112","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Errors/Auth.vue
// module id = KLX5
// module chunks = 0